import * as _ from 'lodash';

export class Line {
    garageCodes: string[] = [];
    routeNumber: string;
    designation: string;
    trafficAreaName?: string;

    public get id(): string {
        return `${this.routeNumber}.${this.trafficAreaName}`;
    }

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }

    public isEqual(comparingLine: Line, excludeKeys?: string[]): boolean {
        let isEqual = true;
        _.each(_.keys(this), key => {
            if(comparingLine[key] !== this[key] && _.indexOf(excludeKeys, key) < 0) {
                isEqual = false;
                return;
            }
        });
        return isEqual;
    }

    public contains(garageCode: string): boolean {
        return _.indexOf(this.garageCodes, garageCode) > -1;
    }

    public add(garageCode: string) {
        if(!this.contains(garageCode)) {
            this.garageCodes.push(garageCode);
        }
    }

    public remove(garageCode: string) {
        if(this.contains(garageCode)) {
            _.remove(this.garageCodes, garageCode);
        }
    }
}
